module.exports = "<aside class=\"al-sidebar\" sidebarResize>\r\n  <ubi-menu [menuHeight]=\"menuHeight\" [sidebarCollapsed]=\"isMenuCollapsed\" (expandMenu)=\"menuExpand()\"></ubi-menu>\r\n  <div class=\"version\">\r\n    v{{appVersion}}\r\n  </div>\r\n</aside>"


//////////////////
// WEBPACK FOOTER
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiSidebar/ubiSidebar.html
// module id = ../../../../../src/app/theme/components/ubiSidebar/ubiSidebar.html
// module chunks = main